import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
// import PropTypes from "prop-types";

import { getCategorizedRoutes } from "api/vehicleRouteApi";
import {
  ALL_BUS_CATEGORIES_OPTIONS,
  PAGE_FORMATTING_BASE,
} from "constants/common";
import { encodeWithSearchParams } from "constants/helper";

import LoadingIndicator from "./LoadingIndicator";
import RoutesTable from "./RoutesTable";

const RouteListRenderer = ({ busRouteCategory, children: description }) => {
  const BUS_CATEGORIES_OPTIONS = ALL_BUS_CATEGORIES_OPTIONS[busRouteCategory];
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const presentSubCategory = searchParams.get("sub_category");

  const [relevantBusRoutes, setRelevantBusRoutes] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchBusRoutes = (routeSubCategory) => {
    getCategorizedRoutes(routeSubCategory).then((response) => {
      setRelevantBusRoutes(response.data);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    if (!presentSubCategory) {
      setSearchParams(
        { sub_category: BUS_CATEGORIES_OPTIONS[0].value },
        { replace: true },
      );
    }
  }, [BUS_CATEGORIES_OPTIONS, presentSubCategory, setSearchParams]);

  useEffect(() => {
    if (presentSubCategory) {
      fetchBusRoutes(presentSubCategory);
    }
  }, [presentSubCategory]);

  return (
    <div className={PAGE_FORMATTING_BASE}>
      <h1 className="text-5xl my-12 text-zinc-800 leading-snug font-semibold">
        {busRouteCategory}
      </h1>

      <section className="leading-relaxed lg:text-justify">
        {description}
      </section>

      <div className="flex flex-wrap bg-accent-back drop-shadow-lg mt-12 mb-8 w-full justify-around">
        {BUS_CATEGORIES_OPTIONS.length > 1 &&
          BUS_CATEGORIES_OPTIONS.map(({ label, value }) => (
            <a
              href={`${location.pathname}?sub_category=${encodeWithSearchParams(value)}`}
              onClick={() => {
                localStorage.removeItem("scrollPos");
                setIsLoading(true);
              }}
              key={value}
              className={`px-10 py-4 ${presentSubCategory === value ? "bg-rose-700 font-semibold text-white" : "hover:text-rose-700"} w-full sm:w-fit`}
            >
              {label}
            </a>
          ))}
      </div>

      {isLoading || !relevantBusRoutes ? (
        <LoadingIndicator />
      ) : (
        <RoutesTable
          isLoading={isLoading}
          relevantBusRoutes={relevantBusRoutes}
        />
      )}
    </div>
  );
};

// RouteListRenderer.propTypes = {
//   busRouteCategory: PropTypes.string,
//   children: PropTypes.node,
// };

export default RouteListRenderer;
